import BaseProxy from './BaseProxy';

class Ad extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/sitePlaces', parameters);
    }
}

export default Ad;



// WEBPACK FOOTER //
// ./src/api/SitePlace.js